import { useEffect, useState } from 'react';
import './MyProjects.scss';
import api from '../../utils/api';
import { Container, Icon, Loader } from 'semantic-ui-react';
import { useNavigate } from "react-router";
import Project from '../../structures/project';
import CreateProjectModal from './components/CreateProjectModal/CreateProjectModal';
import CreateProjectWizard from './components/CreateProjectWizard/CreateProjectWizard';

function MyProjects() {
  const [isLoading, setIsLoading] = useState(true);
  const [projects, setProjects] = useState<Project[]>([]);
  const [isOpenCreateProjectModal, setIsOpenCreateProjectModal] = useState(false)
  const navigate = useNavigate()
  useEffect(() => {
    api.getProjects().then(projects => {setProjects(projects); setIsLoading(false);});
  }, [])
  return <div className='my-projects-page'>
    {isLoading ? <Loader active size='big'/> : <>
		{projects.length === 0 ? <Container className='start-page'>
        <CreateProjectWizard viewWelcomStep onFinish={project=>{
            navigate(`/project/${project.id}`);
        }} />
    </Container> : <>
		<div className='create-project' onClick={()=>{setIsOpenCreateProjectModal(true)}}>
			<div>
				<Icon name='plus' size='big'/>
			</div>
			Создать проект
		</div>
		{projects.map((project) => <div className='project' onClick={() => window.open(`/project/${project.id}`, '_blank')} key={project.id}>{project.name}</div>)}		
		</>}
    </>}
    <CreateProjectModal open={isOpenCreateProjectModal} setOpen={setIsOpenCreateProjectModal} onSave={project => {
        setIsOpenCreateProjectModal(false); 
        api.getProjects().then(projects => {
            setProjects(projects);
            navigate(`/project/${project.id}`);
        });
        }}/>
  </div>;
}

export default MyProjects;
